import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AttendeePage } from './attendee-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AttendeePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AttendeeModalPageRoutingModule {}
